import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Trophy, Clock } from "lucide-react";

export default function ContestBanner() {
  const [c, setC] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    api.get("/contests/active").then((r) => setC(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!c) return;
    const t = setInterval(() => setTick((x) => x + 1), 60000);
    return () => clearInterval(t);
  }, [c]);

  if (!c) return null;
  const remaining = Math.max(0, new Date(c.end_at).getTime() - Date.now());
  const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);

  return (
    <Link to="/contest" className="block" data-testid="contest-banner">
      <div className="card-clay p-4 bg-gradient-to-r from-amber-100 to-amber-50 border-amber-300 flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-amber-500 border-b-4 border-amber-700 flex items-center justify-center flex-shrink-0">
          <Trophy className="text-white" strokeWidth={2.5} size={22}/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-fredoka font-bold text-slate-900 truncate">{c.title}</div>
          <div className="text-xs text-amber-900 truncate"><b>Prize:</b> {c.prize}</div>
        </div>
        <div className="text-right">
          <div className="text-[10px] font-bold uppercase tracking-wider text-amber-700 flex items-center gap-1 justify-end"><Clock size={10}/> Ends in</div>
          <div className="font-fredoka font-bold text-amber-900 whitespace-nowrap" data-testid="contest-countdown">{days}d {hours}h</div>
        </div>
      </div>
    </Link>
  );
}
